import React, { Component, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Table from "components/Table/Table";
import Button from "components/CustomButtons/Button.js";
import Checkbox from "@material-ui/core/Checkbox";
// material-ui icons
import Check from "@material-ui/icons/Check";

import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import { getAllUsers } from "../../services/users/users";

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
});

class Users extends Component {
  constructor(props) {
    super(props);
    this.getUsers = this.getUsers.bind(this);
    this.state = {
      circular: true,
      checked: false,
      users: [["No users found!"]],
    };
  };

  
   handleToggle = value => {
    let { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex ===-1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({checked: newChecked});
  };

  componentDidMount() {
    this.getUsers(this.props.lockerId, this.props.classes);
  }

  getUsers = (lockerId, classes) => {
    let { users, checked } = this.state;

    getAllUsers((data) => {
        let checkbox = ( <Checkbox
            tabIndex={-1}
           
          />)
      users = data.length > 0 ? [] : users;
      data.forEach((user) => {
        let { _id, name, email, lockers, phone, role } = user;
        if (
          lockers &&
          lockers.filter((locker) => locker ===lockerId).length > 0
        )
          users.push([
            checkbox,
            _id.substring(5, 10).toUpperCase(),
            name,
            email ? email : "-",
            role ? role : "-",
          ]);
      });

      
      users = users.length > 0 ? users : [["Nenhum Usuário encontrado!"]];

      this.setState({ users, circular: false });
    });
  };

  

  render() {
    const { circular } = this.state;
    let layout;

    layout = circular ? (
      <Circular />
    ) : (
      <div>
        <Button color="primary">
          Adicionar Novo
        </Button>

        <Table
            striped
          tableHeaderColor="primary"
          tableHead={["", "Id", "Name", "Email", "Função"]}
          tableData={this.state.users}
        />
      </div>
    );

    return <div>{layout}</div>;
  }
}
export default withStyles(useStyles)(Users);
